import { default as _91_46_46_46404_93jkMCcDSgPtMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/[...404].vue?macro=true";
import { default as _91slug_93J94ouZiP9vMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/article/[slug].vue?macro=true";
import { default as _91slug_93B7cLH3ShUGMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/blog/[slug].vue?macro=true";
import { default as cartOECl6hqQKdMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/cart.vue?macro=true";
import { default as checkoutL4KY7tE87SMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/checkout.vue?macro=true";
import { default as _91id_93Y61VjqPxuDMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/collections/[id].vue?macro=true";
import { default as indexzPmvgGartDMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/index.vue?macro=true";
import { default as _91page_93NOwf5j3tkcMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/pages/[page].vue?macro=true";
import { default as _91sku_93SCO8syWN3VMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/products/[sku].vue?macro=true";
import { default as searchkO6HFe3WGqMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/search.vue?macro=true";
import { default as _91order_id_930DfU8KnJFDMeta } from "/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/success/[order_id].vue?macro=true";
export default [
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/[...404].vue")
  },
  {
    name: "article-slug",
    path: "/article/:slug()",
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/article/[slug].vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/blog/[slug].vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkoutL4KY7tE87SMeta || {},
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/checkout.vue")
  },
  {
    name: "collections-id",
    path: "/collections/:id()",
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/collections/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/index.vue")
  },
  {
    name: "pages-page",
    path: "/pages/:page()",
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/pages/[page].vue")
  },
  {
    name: "products-sku",
    path: "/products/:sku()",
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/products/[sku].vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/search.vue")
  },
  {
    name: "success-order_id",
    path: "/success/:order_id()",
    meta: _91order_id_930DfU8KnJFDMeta || {},
    component: () => import("/home/runner/work/hatmeo-nuxt/hatmeo-nuxt/pages/success/[order_id].vue")
  }
]